import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatHorizontalStepper, MatStep } from '@angular/material';
import { CallModel } from 'src/app/shared/models/calllog.model';
import { CategoryModel } from 'src/app/shared/models/category.model';
import { IssueCategoryService } from 'src/app/shared/services/issue-category.service';
import { ProductCategoryService } from 'src/app/shared/services/product-category.service';

@Component({
  selector: 'app-find-issue-step',
  templateUrl: './find-issue-step.component.html',
  styleUrls: ['./find-issue-step.component.css']
})
export class FindIssueStepComponent implements OnInit {
    @Input() call : CallModel;
  //@Input() stepper : MatHorizontalStepper;
  //@Input() mystep : MatStep;
  @Output() onNextSecondStep: EventEmitter<any> = new EventEmitter<any>();
  @Output() onBackSecondStep: EventEmitter<any> = new EventEmitter<any>();

  constructor() { 
   
  }

  ngOnInit() {

   
  }
 

  onNext()
  {   
    //this.mystep.completed = true;
    //this.stepper.next();
    this.onNextSecondStep.emit(this.call);
  }

  onBack()
  {   
   // this.mystep.completed = false;
    //this.stepper.previous();
    this.onBackSecondStep.emit(this.call);
  }

}
